/* eslint-disable import/first */
import React from 'react';

export default function StoreIcon(props) {
  return (
    <svg width="37" height="30" viewBox="0 0 37 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5.78101 28.172H35.266" stroke="#2A5082" stroke-width="1.762" />
      <path
        d="M18.5 10.828V9.672L19.656 6.203V5.047M30.063 10.828V9.672L27.172 6.203V5.047L30.063 10.828ZM24.281 10.828V9.672L23.125 6.203V5.047L24.281 10.828ZM12.719 10.828V9.672L15.609 6.203V5.047L12.719 10.828Z"
        stroke="#BCC0C4"
        stroke-width="1.762"
      />
      <path d="M33.531 11.406V28.172" stroke="#2A5082" stroke-width="1.762" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.719 5.047H30.062V1H12.72V5.047H12.719Z"
        fill="#E9EAEB"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.719 5.047H30.062V1H12.72V5.047H12.719Z"
        stroke="#2A5082"
        stroke-width="1.762"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.93799 10.828V14.297C6.93799 15.796 8.33099 17.187 9.82799 17.187C11.326 17.187 12.718 15.796 12.718 14.297C12.718 15.796 14.112 17.187 15.609 17.187C17.107 17.187 18.5 15.796 18.5 14.297C18.5 15.796 19.893 17.187 21.39 17.187C22.888 17.187 24.281 15.796 24.281 14.297C24.281 15.796 25.674 17.187 27.171 17.187C28.669 17.187 30.063 15.796 30.063 14.297C30.063 15.796 31.456 17.187 32.953 17.187C34.45 17.187 35.843 15.796 35.843 14.297V10.828H6.93799Z"
        fill="#E9EAEB"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.93799 10.828V14.297C6.93799 15.796 8.33099 17.187 9.82799 17.187C11.326 17.187 12.718 15.796 12.718 14.297C12.718 15.796 14.112 17.187 15.609 17.187C17.107 17.187 18.5 15.796 18.5 14.297C18.5 15.796 19.893 17.187 21.39 17.187C22.888 17.187 24.281 15.796 24.281 14.297C24.281 15.796 25.674 17.187 27.171 17.187C28.669 17.187 30.063 15.796 30.063 14.297C30.063 15.796 31.456 17.187 32.953 17.187C34.45 17.187 35.843 15.796 35.843 14.297V10.828H6.93799V10.828Z"
        stroke="#2A5082"
        stroke-width="1.762"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M30.063 5.047H12.718L6.93799 9.462V10.828H35.844V9.462L30.062 5.047H30.063Z"
        stroke="#2A5082"
        stroke-width="1.762"
      />
      <path
        d="M4.62501 28.172H2.31201M12.719 13.14V14.297V13.14ZM18.5 13.14V14.297V13.14ZM24.281 13.14V14.297V13.14ZM30.063 13.14V14.297V13.14Z"
        stroke="#2A5082"
        stroke-width="1.762"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.56197 28.172C8.81697 21.516 15.196 19.856 15.196 14.402C15.196 10.226 11.55 6.90203 7.26697 7.43903C3.60697 7.89903 0.90297 11.223 1.17497 14.902C1.54897 19.965 7.54297 21.724 7.79097 28.172H8.56097H8.56197Z"
        fill="#E4002B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.56197 28.172C8.81697 21.516 15.196 19.856 15.196 14.402C15.196 10.226 11.55 6.90203 7.26697 7.43903C3.60697 7.89903 0.90297 11.223 1.17497 14.902C1.54897 19.965 7.54297 21.724 7.79097 28.172H8.56097H8.56197Z"
        stroke="#FFEBEF"
        stroke-width="1.762"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.406 14.3C10.406 15.58 9.37103 16.616 8.09403 16.616C6.81703 16.616 5.78003 15.58 5.78003 14.3C5.78003 13.021 6.81603 11.984 8.09303 11.984C9.37003 11.984 10.405 13.021 10.405 14.3H10.406Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.406 14.3C10.406 15.58 9.37103 16.616 8.09403 16.616C6.81703 16.616 5.78003 15.58 5.78003 14.3C5.78003 13.021 6.81603 11.984 8.09303 11.984C9.37003 11.984 10.405 13.021 10.405 14.3H10.406Z"
        stroke="#2A5082"
        stroke-width="1.762"
      />
      <path d="M1.156 28.172H0" stroke="#2A5082" stroke-width="1.762" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M24.86 28.172H30.64V20.078H24.86V28.172Z"
        fill="#E9EAEB"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M24.86 28.172H30.64V20.078H24.86V28.172V28.172Z"
        stroke="#2A5082"
        stroke-width="1.762"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15.61 25.281H22.547V20.078H15.609V25.281H15.61Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15.61 25.281H22.547V20.078H15.609V25.281H15.61Z"
        stroke="#2A5082"
        stroke-width="1.762"
      />
      <path d="M35.844 28.172H37" stroke="#2A5082" stroke-width="1.762" />
    </svg>
  );
}
